<template>
    <div class="form-submit">
        <div class="form-submit--wrap">
            <button type="submit"
                    class="form-submit--btn btn btn__medium btn__primary"
                    :class="buttonClasses"
                    ref="submit"
                    :disabled="isPending ? true : null"
                    @click.prevent.stop="onSubmit">

                    <transition name="trs-simple-fade">
                        <cmp-wave-loader
                                class="form-submit--wave-loader"
                                v-if="isPending">
                        </cmp-wave-loader>
                    </transition>

                    <span class="form-submit--btn-content btn--wrap">
                        <span class="btn--text" v-text="label"></span>
                    </span>
            </button>
        </div>

        <div class="form-submit--general-errors" v-if="generalErrors.length">
            <span v-for="(generalError, generalErrorIdx) in generalErrors"
                    class="general-error form-submit--general-error"
                    v-text="generalError">
            </span>
        </div>
    </div>
</template>

<script>
    import bemMixin from 'framework/mixins/bem';
    import isMountedMixin from 'framework/mixins/is-mounted';


    export default {
        mixins: [
            bemMixin('form-submit'),
            isMountedMixin,
        ],
        props: {
            label: {
                type: String,
                required: true,
            },
            isSubmitting: Boolean,
            sitekey: {
                type: String,
                required: true,
            },
            generalErrors: {
                type: Array,
            },
        },
        data() {
            return {
                globals,
                grecaptchaIsInitted: false,
                grecaptchaWidgetId: null,
                isSubmitTriggered: false,
            };
        },
        computed: {
            grecaptchaIsReady() {
                return this.isMounted && this.globals.state.googleRecaptchaLoaded;
            },
            buttonClasses() {
                return [
                    this.bemAdd(this.isPending ? 'is-submitting' : '', 'btn'),
                ];
            },
            isPending() {
                return this.isSubmitTriggered || this.isSubmitting;
            },
        },
        methods: {
            onSubmit() {
                this.isSubmitTriggered = true;

                if (!this.grecaptchaIsReady) {
                    return;
                }

                window.grecaptcha.reset(this.grecaptchaWidgetId);
                window.grecaptcha.execute(this.grecaptchaWidgetId);
            },
            onGrecaptchaSuccess() {
                this.$emit('recaptcha-submit');
            },
        },
        watch: {
            grecaptchaIsReady: {
                handler(val) {
                    if (!val) {
                        return;
                    }

                    this.grecaptchaWidgetId = window.grecaptcha.render(this.$refs.submit, {
                        badge: 'inline',
                        sitekey: this.sitekey,
                        callback: this.onGrecaptchaSuccess,
                    });

                    this.grecaptchaIsInitted = true;
                },
                immediate: true,
            },
            isSubmitting: {
                handler(val) {
                    if (val) {
                        return;
                    }

                    this.isSubmitTriggered = false;
                },
            },
        },
    };
</script>



// WEBPACK FOOTER //
// vehi-industriepfad/assets/src/js/app/framework/components/form/form-submit/index.vue?0abc9e9d